/// <amd-module name="Repos/Tfvc/Views/ShelvesetDetails/Components/ShelvesetDetails" />
import * as React from "react";
import { getTfvcRoutingService } from "Repos/Tfvc/Common/TfvcRoutingService";
import { getTfvcFilesService } from "Repos/Tfvc/Files/TfvcFilesService";
import { getTfvcNavigationService } from "Repos/ChangesCommon/ChangesNavigationService";
import { ChangeDetailsContext, IChangeDetailsContext } from "Repos/Tfvc/Views/ChangeDetails/ChangeDetailsContext";
import { ChangeDetails } from "Repos/Tfvc/Views/ChangeDetails/Components/ChangeDetails";
import * as Resources from "Repos/Tfvc/Views/ShelvesetDetails/Resources";
import { format } from "VSS/Core/Util/String";
import { onClickFPS } from "VSS/Platform/FPS";
import { Components, useComponentContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Uri } from "VSS/Platform/Util/Url";
import { ZeroData, ZeroDataActionType } from "VSSUI/ZeroData";
import { getShelvesetViewService, IShelvesetDetailsViewService } from "../ShelvesetDetailsViewService";
import { getDiscussionIntegrationService } from "../ShelvesetDiscussionIntegrationService";

const ShelvesetDetails = (): JSX.Element => {
    const { pageContext } = useComponentContext();
    let viewService: IShelvesetDetailsViewService;

    try {
        viewService = getShelvesetViewService(pageContext);
    } catch (ex) {
        const actionHref = getTfvcRoutingService(pageContext).getShelvesetsHubUrl();
        const pageUri = new Uri(window.location.href);
        const shelvesetId = pageUri.getQueryParam("ss");

        return (
            <ZeroData
                actionType={ZeroDataActionType.link}
                actionText={Resources.ShelvesetNotFoundAction}
                actionHref={actionHref}
                className="flex-grow"
                imagePath={getAssetLocation(pageContext, "ms.vss-code-web/tfvc-common-content/Content/invalid-path.svg")}
                imageAltText={Resources.ShelvesetNotFoundPrimary}
                onActionClick={e => onClickFPS(pageContext, actionHref, true, e)}
                primaryText={Resources.ShelvesetNotFoundPrimary}
                secondaryText={format(Resources.ShelvesetNotFoundSecondary, shelvesetId)}
            />
        );
    }

    const discussionService = getDiscussionIntegrationService(pageContext);
    const filesService = getTfvcFilesService(pageContext);
    const navigationService = getTfvcNavigationService(pageContext);
    const changeDetailsContext: IChangeDetailsContext = {
        discussionService,
        extensionContext: {
            childComponentProperties: {
                shelvesetName: viewService.getChangeId()
            },
            componentRegion: "shelvesetDetailsExtensions",
            dependencies: ["ms.vss-code-web.shelveset-details-extensions"]
        },
        filesService,
        getFileUrl: path => getTfvcRoutingService(pageContext).getShelvesetDetailsUrl(viewService.getChangeId(), undefined, path),
        navigationService,
        viewService,
        perfContext: {
            pendingWorkName: "shelveset-render-tab",
            scenarioName: "shelveset-details"
        }
    };

    return (
        <ChangeDetailsContext.Provider value={{ ...changeDetailsContext }}>
            <ChangeDetails />
        </ChangeDetailsContext.Provider>
    );
};

Components.add("ms.vss-code-web.tfvc-shelveset-details", ShelvesetDetails);
